import React, { createContext, useReducer } from 'react'
import BeatPlanReducer from './BeatPlanReducer'
const initialState = { beatPlans: [], loading: true }

export const BeatPlanContext = createContext(initialState)

export const BeatPlanContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(BeatPlanReducer, initialState)
  console.log(state);
  function getAllBeatPlans(beatPlans) {
    console.log("in context", beatPlans);
    dispatch({
      type: 'GET_ALL_BEAT_PLANS',
      payload: beatPlans,
    })
  }

  function addNewBeatPlan(beatPlan) {
    dispatch({
      type: 'ADD_BEAT_PLAN',
      payload: beatPlan,
      
    })
  }

  return (
    <BeatPlanContext.Provider
      value={{
        getAllBeatPlans: getAllBeatPlans,
        addNewBeatPlan: addNewBeatPlan,
        beatPlans: state.beatPlans,
        loading: state.loading,
      }}
    >
      {children}
    </BeatPlanContext.Provider>
  )
}

// export {
//   BeatPlanCotext, 
//   BeatPlanCotextProvider, 
// }
